import storageImage from "@/assets/images/hosting/emailhosting-hero2.webp";
import { Check } from 'lucide-react';

export default function EmailHostingHero() {
    return (
        <section className="mb-12 pt-24">
            <div className="container">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                    {/* Left - Content */}
                    <div className="space-y-6">
                        <h2 className="text-3xl lg:text-5xl font-bold text-white leading-tight">
                            Get your own<br />personal email
                        </h2>
                        <p className="text-gray-300 text-base leading-relaxed max-w-xl">
                            Setting up an email address on your domain name (eg. yourname@yourdomain.com) will show your customers that your company/business is professional which in return builds trust and confidence. Plus, you can check your email account from anywhere through our secure email hosting network.
                        </p>

                        {/* Features List */}
                        <div className="space-y-4 pt-4">
                            <div className="flex items-start gap-3">
                                <div className="flex-shrink-0 w-[20px] h-[20px] rounded-full bg-blue-500 flex items-center justify-center mt-1">
                                    <Check className="w-[15px] h-[15px] text-white" strokeWidth={3} />
                                </div>
                                <p className="text-gray-200 text-base">
                                    Connect to Any Domain Name
                                </p>
                            </div>

                            <div className="flex items-start gap-3">
                                <div className="flex-shrink-0 w-[20px] h-[20px] rounded-full bg-blue-500 flex items-center justify-center mt-1">
                                    <Check className="w-[15px] h-[15px] text-white" strokeWidth={3} />
                                </div>
                                <p className="text-gray-200 text-base">
                                    Simple and Easy to setup
                                </p>
                            </div>

                            <div className="flex items-start gap-3">
                                <div className="flex-shrink-0 w-[20px] h-[20px] rounded-full bg-blue-500 flex items-center justify-center mt-1">
                                    <Check className="w-[15px] h-[15px] text-white" strokeWidth={3} />
                                </div>
                                <p className="text-gray-200 text-base">
                                    Access from Anywhere
                                </p>
                            </div>

                            <div className="flex items-start gap-3">
                                <div className="flex-shrink-0 w-[20px] h-[20px] rounded-full bg-blue-500 flex items-center justify-center mt-1">
                                    <Check className="w-[15px] h-[15px] text-white" strokeWidth={3} />
                                </div>
                                <p className="text-gray-200 text-base">
                                    Spam & Virus Protection
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="relative flex justify-center lg:justify-end">
                        <div className="w-full max-w-md">
                            <img
                                    src={storageImage}
                                    alt="Cloud storage"
                                    className="w-full h-auto rounded-3xl"
                                />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}